
import { defineComponent } from 'vue'
import { iGlossary, iNode } from './GlossaryUsage'
import { AxiosResponse } from 'axios'
import Dropdown from 'primevue/dropdown'
import glossaryUsageDescriptor from './GlossaryUsageDescriptor.json'
import GlossaryUsageInfoDialog from './GlossaryUsageInfoDialog.vue'
import GlossaryUsageHint from './GlossaryUsageHint.vue'
import GlossaryUsageDetail from './GlossaryUsageDetail.vue'
import Message from 'primevue/message'
import Tree from 'primevue/tree'

export default defineComponent({
    name: 'glossary-usage',
    components: {
        Dropdown,
        GlossaryUsageInfoDialog,
        GlossaryUsageHint,
        GlossaryUsageDetail,
        Message,
        Tree
    },
    data() {
        return {
            glossaryUsageDescriptor,
            glossaryList: [] as iGlossary[],
            selectedGlossaryId: null as number | null,
            nodes: [] as iNode[],
            buttonVisible: [],
            infoDialogVisible: false,
            contentInfo: null,
            searchWord: null,
            timer: null as any,
            expandedKeys: {},
            selectedKeys: [],
            selectedWords: [] as any[],
            loading: false
        }
    },
    async created() {
        await this.loadGlossary()
    },
    methods: {
        async loadGlossary() {
            this.loading = true
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/glossary/listGlossary')
                .then((response: AxiosResponse<any>) => (this.glossaryList = response.data))
                .finally(() => (this.loading = false))
        },
        async listContents(glossaryId: number, parent: any) {
            this.loading = true

            if (!parent) {
                this.selectedWords = []
                this.selectedKeys = []
                this.loading = false
                return
            }

            if (parent?.WORD_ID || this.searchWord) {
                this.loading = false
                return
            }

            const parentId = parent ? parent.id : null
            let content = [] as iNode[]
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/glossary/listContents?GLOSSARY_ID=${glossaryId}&PARENT_ID=${parentId}`).then((response: AxiosResponse<any>) => {
                response.data.forEach((el: any) => content.push(this.createNode(el)))
                content.sort((a: iNode, b: iNode) => (a.label > b.label ? 1 : -1))
            })

            this.attachContentToTree(parent, content)
            this.loading = false
        },
        attachContentToTree(parent: iNode, content: iNode[]) {
            if (parent) {
                parent.children = []
                parent.children = content
            } else {
                this.nodes = []
                this.nodes = content
            }
        },
        async showInfo(content: any) {
            this.loading = true
            const url = content.CONTENT_ID ? `1.0/glossary/getContent?CONTENT_ID=${content.CONTENT_ID}` : `1.0/glossary/getWord?WORD_ID=${content.WORD_ID}`
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url)
                .then((response: AxiosResponse<any>) => {
                    this.contentInfo = response.data
                    this.infoDialogVisible = true
                })
                .finally(() => (this.loading = false))
        },
        async filterGlossaryTree() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            let tempData = []
            this.timer = setTimeout(() => {
                this.loading = true
                this.$http
                    .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/glossary/glosstreeLike?WORD=${this.searchWord}&GLOSSARY_ID=${this.selectedGlossaryId}`)
                    .then((response: AxiosResponse<any>) => (tempData = response.data))
                    .finally(() => {
                        this.createGlossaryTree(tempData)
                        this.loading = false
                    })
            }, 1000)
        },
        createGlossaryTree(data: any) {
            this.nodes = []
            this.expandedKeys = {}
            data.GlossSearch.SBI_GL_CONTENTS.forEach((el: any) => {
                const tempNode = this.createNode(el)
                el.CHILD?.forEach((el: any) => {
                    tempNode.children.push(this.createNode(el))
                })
                this.nodes.push(tempNode)
            })
            this.expandAll()
        },
        createNode(el: any) {
            return {
                key: el.CONTENT_ID ?? el.WORD_ID,
                id: el.CONTENT_ID ?? el.WORD_ID,
                label: el.CONTENT_NM ?? el.WORD,
                children: [] as iNode[],
                data: el,
                style: this.glossaryUsageDescriptor.node.style,
                leaf: !(el.HAVE_WORD_CHILD || el.HAVE_CONTENTS_CHILD),
                selectable: !(el.HAVE_WORD_CHILD || el.HAVE_CONTENTS_CHILD)
            }
        },
        expandAll() {
            for (let node of this.nodes) {
                this.expandNode(node)
            }
            this.expandedKeys = { ...this.expandedKeys }
        },
        expandNode(node: iNode) {
            if (node.children && node.children.length) {
                this.expandedKeys[node.key] = true
                for (let child of node.children) {
                    this.expandNode(child)
                }
            }
        },
        showNavigationItemInfo(info: any) {
            this.contentInfo = info
            this.infoDialogVisible = true
        },
        onNodeSelect(node: iNode) {
            this.selectedWords.push(node.data)
        },
        onNodeUnselect(node: iNode) {
            const index = this.selectedWords.findIndex((el: any) => el.id === node.data.WORD_ID)
            this.selectedWords.splice(index, 1)
        },
        onDragStart(event: any, node: iNode) {
            event.dataTransfer.setData('text/plain', JSON.stringify(node.data))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
        },
        setFilteredWords(words: any) {
            this.loading = true
            this.nodes = []
            words.forEach((el: any) => this.nodes.push(this.createNode(el)))

            this.loading = false
        },
        setLoading(value: boolean) {
            this.loading = value
        }
    }
})
